// Helper to split heavy synchronous loops into smaller batches to avoid blocking the main thread.
// This is used to keep the boot resilient when extensions (e.g. ad blockers) generate long tasks.
export type ChunkScheduler = (cb: () => void) => void;

const idleScheduler: ChunkScheduler = (cb) => {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    // requestIdleCallback keeps the UI responsive; fallback preserves behavior if unavailable.
    (window as unknown as { requestIdleCallback: (fn: () => void, opts?: IdleRequestOptions) => void }).requestIdleCallback(cb, { timeout: 250 });
    return;
  }

  setTimeout(cb, 0);
};

interface RunInChunksOptions {
  chunkSize?: number;
  scheduler?: ChunkScheduler;
}

export function runInChunks<T>(
  items: readonly T[],
  worker: (item: T, index: number) => void,
  { chunkSize = 4, scheduler = idleScheduler }: RunInChunksOptions = {},
): Promise<void> {
  return new Promise((resolve) => {
    let index = 0;

    const processChunk = () => {
      const limit = Math.min(index + chunkSize, items.length);
      for (; index < limit; index += 1) {
        worker(items[index], index);
      }

      if (index < items.length) {
        scheduler(processChunk);
        return;
      }

      resolve();
    };

    scheduler(processChunk);
  });
}

export const scheduleIdle = idleScheduler;
